module.exports = __webpack_public_path__ + "img/王浩.3b9ced9d.jpg";